<template>
  <div class="container">
    <h1 class="page-title_hidden" id="page-title-for-sr">{{ $t('paywall.processing.pageTitle') }}</h1>
    <div class="columns loader"><span class="sr-only">{{ $t('paywall.processing.loaderAnimation') }}</span>
      <section class="sidebar-column" v-if="transaction">
        <order-details-side :transaction="transaction"
                            :visibility="visibilityOptions"
                            :show-button="false" />
      </section>
      <section class="main-column">
        <div class="content">
          <div class="payment-processing-loader-wrapper">
            <result-processing-loader />
            <div class="loader-text">
              <h2>{{ $t('result.pending.header') }}</h2>
              <p>{{ $t('result.pending.description') }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ResultProcessingLoader from './ResultLoader'
import OrderDetailsSide from '@/base/components/OrderDetails/Side'
import loadingMixin from '@/base/mixins/loading.mixin'
import { ToolsClass } from '@/base/class/tools.class'

export default {
  name: 'ResultProcessing',
  mixins: [loadingMixin],
  components: {
    OrderDetailsSide,
    ResultProcessingLoader
  },
  computed: {
    ...mapState({
      transaction: state => state.result.data?.transaction,
      visibilityOptions: state => state.result.data.visibilityOptions
    })
  },
  created () {
    ToolsClass.scrollToElementTop(document.querySelector('header'))
  }
}
</script>

<style lang="scss" scoped>
@import "./src/base/assets/scss/components/_processing-loader.scss";
</style>
